export default __webpack_public_path__ + "build/9b701905b3e5450bb8a93e8fc385e909.svg";